export default __webpack_public_path__ + "static/media/icon-route-fill.5cdcf2b5.svg";